import React from 'react';

interface SkeletonProps {
    className?: string;
    variant?: 'text' | 'rectangular' | 'circular';
}

export function Skeleton({ className = '', variant = 'rectangular' }: SkeletonProps) {
    const baseClass = "animate-pulse bg-surface-alt dark:bg-surface-dark-alt/50";

    const variantClasses = {
        text: 'h-4 w-full rounded',
        rectangular: 'rounded-2xl',
        circular: 'rounded-full'
    };

    return (
        <div
            className={`${baseClass} ${variantClasses[variant]} ${className}`}
            aria-hidden="true"
        />
    );
}

export function NewsCardSkeleton() {
    return (
        <div className="flex flex-col gap-4 bg-surface-secondary dark:bg-surface-dark-secondary rounded-2xl overflow-hidden border border-border-default dark:border-white/10 p-4">
            <Skeleton className="aspect-[16/9] w-full" />
            <div className="flex flex-col gap-2">
                <Skeleton variant="text" className="w-1/3" />
                <Skeleton variant="text" className="h-6" />
                <Skeleton variant="text" className="h-6 w-5/6" />
            </div>
        </div>
    );
}
